import React from "react";
import { useSelector } from "react-redux";
import CustomHorizontalBarChart from "../BusinessGrants/CustomHorizontalBarChart";

const WaterSourceChart = () => {
  const waterSourceGraphFilter = useSelector(
    (state) => state.dashboard?.waterSourceGraphCount
  );

  const data = [
    { name: "Tap Water", value: waterSourceGraphFilter?.TapWater || 0 },
    { name: "Hand Pump", value: waterSourceGraphFilter?.HandPump || 0 },
    { name: "Dug Well", value: waterSourceGraphFilter?.DugWell || 0 },
    { name: "Rain Water", value: waterSourceGraphFilter?.RainWater || 0 },
    { name: "Surface Water", value: waterSourceGraphFilter?.SurfaceWater || 0 },
  ];

  return (
    <div className="lg:col-span-3">
      <div className="text-center mb-3">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Water Source Distribution
        </h3>
        <div className="bg-white rounded-lg p-3 mt-3">
          <div className="h-30 overflow-y-auto">
            <CustomHorizontalBarChart data={data} color="#5A9BA8" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaterSourceChart;
